import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Slide } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useRemoveSiteMutation } from '../../services/api';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteSiteDialogBox = ({ open, onClose, site, refetch }) => {
    const theme = useTheme();
    const [removeSite, { isLoading }] = useRemoveSiteMutation();

    // Handle delete
    const handleDelete = async () => {
        try {
            await removeSite(site._id).unwrap();
            refetch();
            onClose();
        } catch (error) {
            console.error('Failed to delete site:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            PaperProps={{
                sx: {
                    backgroundColor: theme.palette.background.paper,
                    width: '600px',
                    padding: theme.spacing(2),
                },
            }}
        >
            <DialogTitle sx={{ color: theme.palette.text.white }} variant="h2" fontWeight="bold">
                Confirm Delete
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1" color="text.primary">
                    Are you sure you want to delete site <strong>{site?.name}</strong>?
                </Typography>
            </DialogContent>

            <DialogActions sx={{ padding: theme.spacing(2) }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.text.white,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.text.white,
                        },
                    }}
                    disabled={isLoading}
                >
                    Cancel
                </Button>

                <Button
                    onClick={handleDelete}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.error.main,
                        fontWeight: 'bold',
                        '&:hover': {
                            backgroundColor: theme.palette.error.dark,
                        },
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteSiteDialogBox;
